// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"Tags_tagsWrapper__FEuD5","tagCard":"Tags_tagCard__bM73n","bgImg":"Tags_bgImg__JxUlU"};